import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

/**
 * @returns {boolean}
 */
export const useEnablePickToTote = () => useFeatureFlag(FeatureFlagDeclarations.enablePickToTote);
